import Button from "../../componentes/button/button";

export default function PreviewAssinatura({ imagemUrl, onExcluir, excluindo }) {
    function confirmarExclusao() {
        if (window.confirm("Deseja realmente remover sua assinatura?")) {
            onExcluir();
        }
    }

    return (
        <div className="flex flex-col gap-3">
            <h3 className="text-sm font-semibold text-foreground">Assinatura Atual</h3>

            <div className="border border-border rounded-lg bg-muted/40 flex items-center justify-center min-h-40 p-4">
                {imagemUrl ? (
                    <img src={imagemUrl} alt="Assinatura atual" className="max-h-36 max-w-full object-contain" />
                ) : (
                    <div className="flex flex-col items-center gap-1.5 text-center py-4">
                        <i className="fa fa-signature text-2xl text-muted-foreground" />
                        <p className="text-sm text-muted-foreground">Nenhuma assinatura cadastrada</p>
                    </div>
                )}
            </div>

            {imagemUrl && (
                <div className="flex justify-end">
                    <Button
                        variant="red"
                        label="Remover assinatura"
                        iconLeft="fa fa-trash"
                        onClick={confirmarExclusao}
                        loading={excluindo}
                    />
                </div>
            )}
        </div>
    );
}
